// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"487cf8b1","835":"081c3086"}[chunkId] + ".chunk.js";
};